<template>
<div class="popup" v-cloak v-if="deleteTaskShow">
    <div class="content" id="deleteTask">
        <div class="title">
              {{$t('language.popup.taskListPopup.deleteTask')}}
            <div class="icon white-close dialog-close" @click="deleteTaskShow=false"></div>
        </div>
        <div class="delete-body">
            <div class="delete-info">
                <div>{{$t('language.popup.taskListPopup.deleteSingleTask')}}</div>
                <div v-if="false">{{$t('language.popup.taskListPopup.sureDeleteTask')}}</div>
            </div>
            <div class="delete-task-button">
                <button @click="deleteTask(deleteItem)">{{$t('language.common.delete')}}</button>
            </div>
        </div>

    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            deleteItem: {},
            deleteTaskShow: false,
        }
    },
    methods: {
        deleteTask(task) {//发送删除单个任务请求
            let taskType;
            let deleteData = this.getDeleteData(task);
            let that=this;
            if(task.branchType!='realtime'){
                if(task.lowerType == 104){
                   this.deleteBusinessTransfer(task);
                   return;
                }
                if(task.type == 5) {
                    //如果是种子或者磁力链接
                    this.Utils.doTorrentRequest("delete", deleteData).then(res => {
                        if (res.status == 200) {
                            that.deleteTaskRespone(deleteData);
                        }else{
                            that.$toast({
                                text: that.$t('language.exception.'+ res.reason),
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        }
                    }, err => {
                        that.$toast({
                            text: err,
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    });
                }else {
                    this.Utils.doTasksRequest("delete", deleteData).then(res => {
                        if (res.status == 200) {
                            that.deleteTaskRespone(deleteData);
                        }else{
                            that.$toast({
                                text: that.$t('language.exception.'+ res.reason),
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                        }
                    }, err => {
                        that.$toast({
                            text: err,
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    });
                }
            }else{
                //删除即时同步任务
                this.Utils.doRealtimeSyncRequest('cancel', deleteData).then(res => {
                if (res.message == 'success') {
                    that.deleteTaskRespone(deleteData);
                }else{
                        that.$toast({
                                text: that.$t('language.exception.deleteItemFailed'),
                                type: 'fail',
                                idValue: "rightBodyList"
                            });
                }
                }, err => {
                        that.$toast({
                            text: err,
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                    });
            }
        },
        //删除数据成功后的操作
        deleteTaskRespone(deleteData){
            let that = this;
            let allGroupArr=Object.assign([],that.$store.state.taskListArr);
            console.log('allGroupArr',allGroupArr)
            if(that.deleteItem.groupId){//返回未删除的数据
                that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
                    return item.groupId!=deleteData.gd;
                });
            }else{
                that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
                    return item.id!=deleteData.id;
                });
            }
            this.deleteTaskShow = false;
        },
        getDeleteData(task){
         let deleteData;
          if (task.isMultiTask&&task.type!=6) {
                 deleteData=new taskListUtils.deleteTaskData(commonUtils.getUser().id,task.type,null,task.id);
            } else {
                 deleteData=new taskListUtils.deleteTaskData(commonUtils.getUser().id,task.type,task.id,null);
            }
         return deleteData;
        },
        //删除企业云盘任务
        deleteBusinessTransfer(task){
          var deleteData={
              id:task.id,
              ud:commonUtils.getUser().id
           }
           var that=this;
            this.Utils.doBusinessTransferRequest('delete', deleteData).then(res => {
               that.deleteTaskRespone(deleteData);
             }).catch(err =>{
				 if (err.reason) {
				   err = that.$t('language.exception.' + err.reason)
				 }
				    that.$toast({
				        text: err,
				        type: 'fail',
				        idValue: "rightBodyList"
				    });
			 });
        }
         
    }
}
</script>

<style scoped>
#deleteTask {
    width: 500px;
    /*no*/
    height: 180px;
    /*no*/
}

.delete-body {
    width: 100%;
    /*no*/
    height: 140px;
    /*no*/
    color: #6f7886;
    padding-left: 20px;
    /*no*/
    box-sizing: border-box;

}

.delete-info {
    width: 100%;
    position: relative;
    top: 40px;
    /*no*/
    float: left;

}

.delete-task-button {
    float: right;
    top: 70px;
    /*no*/
    right: 20px;
    /*no*/
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/delete_task_popups.vue